import React, { useState, useEffect } from "react";
import Select from "react-select";
import TitleComponent from "../../components/TitleComponent";
import Form from "../../components/AnimationForm";
import { capitalize } from "../../lib/helper";
import { notify } from "react-notify-toast";
import api from "../../api";
import isEmpty from "lodash.isempty";
import produce from "immer";
import moment from "moment";
import config from "../../config";
import Loader from "../../components/LoaderComponent";
import useTranslation from "../../i18n/useTranslation";
import { formatWeekday } from "../../i18n/dates";

const uuid = require("uuid/v4");

export default function New(props) {
   const { t, locale } = useTranslation();
   const { state } = props.location;
   const dateFormat = config.get("dateFormat");

   const [formsData, setFormsData] = useState([]);
   const [dataFetching, setDataFetching] = useState(true);

   useEffect(() => {
      parseForms();
      //eslint-disable-next-line
   }, []);

   const parseForms = () => {
      const forms = [];
      state.animations.forEach((animation) => {
         forms.push({
            formId: animation.animacjaID,
            dane: {
               godzDo: animation.dane.godzDo,
               godzOd: animation.dane.godzOd,
               uwagi: animation.dane.uwagi
            },
            data: moment(state.day).format(dateFormat),
            hotel: {
               id: state.hotelId,
               nazwa: state.hotel
            },
            kodProduktu: state.productKey.value
         });
      });
      setFormsData(forms);
      setDataFetching(false);
   };

   const createForm = () => {
      const forms = [...formsData];
      forms.push({
         formId: uuid(),
         method: "POST",
         dane: { godzDo: "", godzOd: "", uwagi: "" },
         data: moment(state.day).format(dateFormat),
         hotel: { id: state.hotelId, nazwa: state.hotel },
         kodProduktu: state.productKey.value
      });
      setFormsData(forms);
   };

   const handleChange = (id, data) => {
      const forms = produce(formsData, (draft) => {
         const index = draft.findIndex((form) => form.formId === id);
         if (draft[index].method !== "POST") draft[index].method = "PUT";
         Object.assign(draft[index].dane, data);
      });
      setFormsData(forms);
   };

   const handleRemove = (id) => {
      const forms = produce(formsData, (draft) => {
         const index = draft.findIndex((form) => form.formId === id);
         if (draft[index].method === "POST") {
            draft.splice(index, 1);
         } else {
            draft[index] = { formId: id, method: "DELETE" };
         }
      });
      setFormsData(forms);
   };

   const validateForms = () => {
      let requirementsMet = true;
      const requiredFields = ["godzOd", "godzDo", "uwagi"];
      formsData.forEach((form) => {
         if (form.method === "DELETE") return;
         requiredFields.forEach((element) => {
            if (isEmpty(form.dane[element])) requirementsMet = false;
         });
      });
      return requirementsMet;
   };

   const saveChanges = () => {
      if (!validateForms())
         return notify.show(t("toasts.fillAllForms"), "warning", 3000);
      setDataFetching(true);
      const promiseArray = [];
      let promise;
      formsData.forEach((form) => {
         switch (form.method) {
            case "POST":
               promise = api
                  .createAnimation(form)
                  .then((resp) => resp)
                  .catch((err) => err);
               promiseArray.push(promise);
               break;
            case "PUT": {
               const changedForm = Object.assign({}, form, { animacjaID: form.formId });
               promise = api
                  .editAnimation(changedForm)
                  .then((resp) => resp)
                  .catch((err) => err);
               promiseArray.push(promise);
               break;
            }
            case "DELETE":
               promise = api
                  .deleteAnimation(form.formId)
                  .then((resp) => resp)
                  .catch((err) => err);
               promiseArray.push(promise);
               break;
            default:
               return;
         }
      });
      Promise.all(promiseArray).then(() => {
         setDataFetching(false);
         props.history.push("/animation-scheduler");
      });
   };

   const renderForms = () => {
      return formsData.map((form) => {
         if (form.method === "DELETE") return false;
         return (
            <Form
               key={form.formId}
               formId={form.formId}
               data={form.dane}
               handleChange={handleChange}
               handleRemove={handleRemove}
            />
         );
      });
   };

   return (
      <div className="hotels__slide">
         <TitleComponent className="section_title--width-unset">
            {capitalize(formatWeekday(state.day, locale))}, {state.hotel}
         </TitleComponent>
         <Loader show={dataFetching} />
         <div className="container_desktop" style={{ margin: "0 auto" }}>
            {renderForms()}
            <div className="margin--top">
               <Select
                  options={[{ value: "new_form", label: t("tasks.types.animacja") }]}
                  value={null}
                  placeholder={t("animations.addAnimation")}
                  onChange={createForm}
               />
            </div>
            <div
               style={{ marginTop: "25px" }}
               className="center margin--bottom button_container flex flex--space-around"
            >
               <button
                  onClick={() => props.history.push("/animation-scheduler")}
                  className="btn button__transparent button__rounded button__rounded--flat"
               >
                  <strong>{t("common.actions.back")}</strong>
               </button>
               <button className="btn button__secondary button__rounded" onClick={saveChanges}>
                  {t("common.actions.saveChanges")}
               </button>
            </div>
         </div>
      </div>
   );
}
